import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

export const useOrderStore = defineStore('order', () => {
	const cart = ref([]);
	const tips = ref(0);

	function addProduct(product) {
		const item = cart.value.find(i => i.product.id === product.id);

		if (item) {
			item.amount++;
		} else {
			cart.value.push({ product, amount: 1 });
		}
	}

	function removeProduct(product) {
		const item = cart.value.find(i => i.product.id === product.id);
		if (item) {
			item.amount--;
			if (item.amount <= 0) {
				cart.value = cart.value.filter(i => i.product.id !== product.id);
			}
		}
	}

	function removeAllByProductId(productId) {
		cart.value = cart.value.filter(i => i.product.id !== productId);
	}

	// Очистить корзину
	function clearCart() {
		cart.value = [];
		tips.value = 0;
	}

	// Получить количество конкретного продукта
	function getAmount(productId) {
		const item = cart.value.find(i => i.product.id === productId);
		return item ? item.amount : 0;
	}

	const subtotal = computed(() => {
		return cart.value.reduce((sum, item) => {
			return sum + item.product.price * item.amount;
		}, 0);
	});

	const tipsAmount = computed(() => {
		return +(subtotal.value * (tips.value / 100)).toFixed(2);
	});

	// Общая сумма
	const total = computed(() => {
		return +(subtotal.value + tipsAmount.value).toFixed(2);
	});


	return {
		cart,
		tips,
		total,
		addProduct,
		removeProduct,
		removeAllByProductId,
		clearCart,
		getAmount,
	};
});
